module.exports = __webpack_public_path__ + "media/כף.a0dac839.mp3";